import { PageTabless } from '../../components';
import { useContent } from '../../hooks/use-content';

export const CorporateInformationPage = () => {
  const content = useContent();
  const contentKeyPage = content.t('portal.corporateInformation', { date: `2022 - ${new Date().getFullYear()}` });

  return (
    <PageTabless>
      <div dangerouslySetInnerHTML={{ __html: contentKeyPage }} />
    </PageTabless>
  );
};
